<template>
  <TsSection>
    <TsTitle append-class="my-2" title="News" />

    <div class="mt-2" v-if="!route.query.category && !route.query.tag">
      <TsGrid :rows="1" :cols="2.4" :spaceX="2" class="py-5">
        <TsColumn>
          <TsInput v-model="selectedQuery" placeholder="Search"
            @keyup.enter="builderStore.redirectToNewsWithInputQuery(selectedQuery)" rounded
            icon="material-symbols-light:search" iconPosition="right">
            <template #right>
              <TsIcon class="cursor-pointer" size="1.5rem" name="system-uicons:cross" v-if="selectedQuery" @click="navigateTo('/news')" />
            </template>
          </TsInput>
        </TsColumn>
      </TsGrid>
    </div>

    <TsAlert v-if="builderStore.news.length > 0" :content="`${builderStore.news.length} items`">
      <template #alert-msg>
        <TsTypography>
          Search results for <strong> {{ route.query.tag || selectedQuery || route.query.category }} </strong>
        </TsTypography>
      </template>
    </TsAlert>

    <TsRow class="justify-center" v-if="builderStore.news.length === 0">
      <TsTypography>
        No results were found for <strong> {{ route.query.tag || selectedQuery || route.query.category }} </strong>
      </TsTypography>
    </TsRow>

    <TsGrid :rows="1" :cols="3" :spaceX="2" class="py-5" v-else>
      <div v-for="el in news" :key="el.id">
        <TsNewsCard :data="el.data" />
      </div>
    </TsGrid>

    <TsRow class="justify-center mt-2" v-if="builderStore.news?.length">
      <TsPagination :dataLength="builderStore.news?.length" type="stepless" withText :offset="limit"
        :activePageNumber="currentPage" @change="changeActivePage" @prev="changeActivePage" @next="changeActivePage"
        @first="changeActivePage" @last="changeActivePage" />
    </TsRow>

  </TsSection>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useBuilderStore } from "../../../stores/builder.store";

const TsGrid = defineAsyncComponent(() => import('~/components/organisms/TsGrid.vue'));
const TsNewsCard = defineAsyncComponent(() => import('~/components/organisms/TsNewsCard.vue'));
const TsPagination = defineAsyncComponent(() => import('~/components/molecules/TsPagination.vue'));

const route = useRoute()
const router = useRouter();
const builderStore = useBuilderStore();
const currentPage = ref(1);
const limit = 6;

useHead({
  title: 'News | Toolstation',
  meta: [
    {
      name: 'description',
      content: 'This is the news listing page of Toolstation.'
    }
  ]
})

const news = ref([]);

const selectedQuery = ref(route.query.q || '');

async function fetchNews() {
  const offset = (currentPage.value - 1) * limit;
  if (route.query.tag) {
    await builderStore.getNewsList('news', { 'data.tags.$in': [route.query.tag] });
  } else if (route.query.category) {
    await builderStore.getNewsList('news');
    builderStore.news = builderStore.news.filter(news => news?.data?.categories?.value?.data?.slug === route.query.category);
  } else if (selectedQuery.value) {
    await builderStore.getNewsList('news', { 'data.title': { $regex: selectedQuery.value, $options: 'gi' } });
  }
  news.value = builderStore.news.slice(offset, offset + limit);
}

watch([currentPage, () => route.query.q], ([_, q]) => {
  if (q === '') {
    router.push({ path: '/news' });
    return;
  }
  fetchNews();
});

function changeActivePage(page: number) {
  currentPage.value = page;
}

onMounted(async () => {
  await fetchNews();
})
</script>